import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import logo from '../asset/img/logo.png'
import '../page/Home.css'

function MyCourses({ activeNav, setActiveNav, myauth }) {
    const [list, setlist] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [activeTab, setActiveTab] = useState('Ongoing');
    const [notificationsOpen, setNotificationsOpen] = useState(false);

    useEffect(() => {
        const fetchStudentData = async () => {
            if (!myauth || !myauth.email) return;
            try {
                const response = await fetch(`https://mmao.vercel.app/student/course?email=${encodeURIComponent(myauth.email)}`);
                const resJson = await response.json();

                if (resJson.status === 'success' && resJson.data) {
                    setlist(resJson.data);
                } else {
                    setlist([]);
                }
            } catch (err) {
                console.error('Error fetching student progress:', err);
                setlist([]);
            } finally {
                setlist(false);
            }
        };

        fetchStudentData();
    }, [myauth]);
    return (
        <>
            <main className="main-content">
                <header className="top-header">
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                        <Link className="logo">
                            <img src={logo} alt='' />
                            <span>MMao</span>
                        </Link>
                        <div className="search-box">
                            <i class="ri-search-line"></i>
                            <input
                                type="text"
                                placeholder="Search courses, resources..."
                                value={searchQuery}
                                maxLength={45}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="header-actions">
                        <button className="icon-btn profilebtn" onClick={() => {
                            document.querySelector('.blurdiv').style.display = 'flex';
                            document.querySelector('.right-sidebar').style.right = 0;
                        }}>
                            <i class="ri-user-3-fill"></i>
                        </button>
                    </div>
                </header>
                <div className="page-title-row">
                    <h1 className="page-title">{activeNav}</h1>
                    <div className="filter-tabs">
                        {['Ongoing', 'Favorite', 'Complete'].map((tab) => (
                            <button
                                key={tab}
                                className={`filter-tab ${activeTab === tab ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>

                { }
                <div className="courses-grid">
                    {/* Lower Side-by-Side Cards */}
                    <div className="lower-cards-row">
                        {/* Photography Card */}
                        <p>{myauth.email}</p>
                        {list && list.map((item) => (
                            <Link key={item.id} to={'/course/webdev1shn'} className="small-card">
                                <div>
                                    <div className="small-card-header">
                                        <div className="card-icon-box photo-bg">👨🏻‍💻</div>
                                        <span className='card-label'>Online/Offline</span>
                                    </div>
                                    <h3 className="small-card-title">ႁဵၼ်းတႅမ်ႈၶူတ်ႉ Web development 1</h3>
                                    <p className="small-card-desc">ႁဵၼ်းသွၼ်တႅမ်ႈၶူတ်ႉၶူင်သၢင်ႈဝႅပ်ႉသၢႆႉတႃႇၽူႈတီႈဢၼ်ဢမ်ႇပႆႇမေႃသင်တႄႇပိုၼ်ႉၶၢမ်ႇတေႃႇထိုင်ၸၼ်ႉ frontend</p>
                                </div>
                                <div className="small-card-footer">
                                    <span>30 Lessons</span>
                                    <span>8h 9m 25s</span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </main>
            <nav className="bottom-nav-menu">
                {[
                    { name: 'Home', icon: 'ri-home-3-fill' },
                    { name: 'My courses', icon: 'ri-folder-video-fill' },
                    { name: 'Documents', icon: 'ri-article-fill' },
                    { name: 'Reviews', icon: 'ri-chat-ai-4-fill' },
                    { name: 'Profile', icon: 'ri-user-3-fill' }
                ].map((item) => (
                    <button
                        key={item.name}
                        className={`bottom-nav-item ${activeNav === item.name ? 'active' : ''}`}
                        onClick={() => setActiveNav(item.name)}
                    >
                        <i class={item.icon}></i>
                        <span>{item.name}</span>
                    </button>
                ))}
            </nav>
        </>
    )
}

export default MyCourses